import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export default class FreespinRecord extends SpinRecord {

    public remainingFreespins: number = 0;
    public isFreespinsComplete: boolean = false;
    public gameName: string = "";
    public totalFreespins: number = 0;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/records/freespin-record.ts